import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction(
    'updateSelectedLogIndexMutator',
    function updateSelectedLogIndexMutator(newIndex: number) {
        getStore().selectedLogIndex = newIndex;
    }
);
